module.exports = "<div class=\"aside\" id=\"addBank\" content>\n    <ui-view></ui-view>\n</div>\n"


/*****************
 ** WEBPACK FOOTER
 ** ./pages/xo-sidebar-add-bank/template.html
 ** module id = 335
 ** module chunks = 1
 **/